export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Insgesamt generierte Bilder',
        cost: 'Kosten',
        imagesPerDay: 'Bilder/Tag',
    },
};
